const responseHasErrors = (response = {}) => {
  return !!(
    response.data &&
    response.data.errors &&
    response.data.errors.length
  );
};

export { responseHasErrors };



// WEBPACK FOOTER //
// ./src/utils/ApiHelper.js